'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_ROOT:'"http://127.0.0.1:9090"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1